import { render, staticRenderFns } from "../templates/culled.pug?vue&type=template&id=631b7966&scoped=true&lang=pug&"
import script from "./Culled.vue?vue&type=script&lang=js&"
export * from "./Culled.vue?vue&type=script&lang=js&"
import style0 from "./Culled.vue?vue&type=style&index=0&id=631b7966&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b7966",
  null
  
)

export default component.exports